// extracted by mini-css-extract-plugin
export default {"marcWrapper":"marcWrapper---Azy9T","marc":"marc---_LV2N"};